module.exports = __webpack_public_path__ + "img/nav-right-with-contact-toolbar-cjdr.c9986c4c.png";